var jform;

jform = function() {
  var $, errorMyField, initValidationSwitch, module, moduleName, setDefault, updatePlaceholder;
  moduleName = 'jform';
  $ = require('jquery');
  module = $("form." + moduleName);
  updatePlaceholder = function(thisInput, response, untrigger) {
    thisInput.removeAttr('placeholder');
    thisInput.attr('placeholder', response);
    thisInput.val('');
    if (untrigger !== true) {
      return thisInput.trigger('change');
    }
  };
  setDefault = function(thisInput, defPlaceholder) {
    defPlaceholder = '';
    updatePlaceholder(thisInput, defPlaceholder, true);
    if (thisInput.parents("." + moduleName).hasClass("jform--b-form")) {
      return thisInput.removeClass('b-form__input--error');
    } else {
      return thisInput.parent().removeClass(moduleName + "__field--error");
    }
  };
  errorMyField = function(thisInput, response) {
    if (thisInput.parents("." + moduleName).hasClass("jform--b-form")) {
      thisInput.addClass('b-form__input--error');
    } else {
      thisInput.parent().addClass(moduleName + "__field--error");
    }
    updatePlaceholder(thisInput, response, false);
    return false;
  };
  initValidationSwitch = function(thisInput) {
    var isMatched, j, len, mainValSwitcher, results, thisInputType, thisInputTypeArray, thisInputVal;
    thisInputType = thisInput.data('type');
    if (thisInputType !== void 0) {
      thisInputTypeArray = thisInput.data('type').split(' ');
      thisInputVal = thisInput.val();
      isMatched = function(value, regexp, err, noErrored) {
        var response;
        if (value !== '') {
          if (value.match(regexp)) {
            return true;
          } else {
            if (noErrored === true) {
              return false;
            } else {
              response = err;
              return errorMyField(thisInput, response);
            }
          }
        } else {
          return true;
        }
      };
      mainValSwitcher = function(thisInputType) {
        var err, linkRegexp, mailRegxep, noErrored, phoneRegexp, regexp, response;
        switch (thisInputType) {
          case 'required':
            if (thisInputVal === '') {
              response = 'Заполните поле';
              errorMyField(thisInput, response);
              return false;
            } else {
              return true;
            }
            break;
          case 'link':
            err = 'Ссылка невалидна';
            linkRegexp = new RegExp(/[-a-zA-Z0-9@:%_\+.~#?&\/\/=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&\/\/=]*)?/gi);
            if (isMatched(thisInputVal, linkRegexp, err) === true) {
              return true;
            } else {
              return false;
            }
            break;
          case 'mail-or-phone':
            err = 'Проверьте данные';
            phoneRegexp = /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/;
            mailRegxep = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            noErrored = true;
            if (isMatched(thisInputVal, phoneRegexp, err, noErrored) === true || isMatched(thisInputVal, mailRegxep, err, noErrored) === true) {
              console.log('ok');
              return true;
            } else {
              console.log('ok');
              errorMyField(thisInput, err);
              return false;
            }
            break;
          case 'mail':
            err = 'Проверьте данные';
            mailRegxep = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (isMatched(thisInputVal, mailRegxep, err) === true) {
              return true;
            } else {
              return false;
            }
            break;
          case 'phone':
            err = 'Номер введён неправильно';
            regexp = /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/;
            if (isMatched(thisInputVal, regexp, err) === true) {
              return true;
            } else {
              return false;
            }
            break;
          case "workemail":
            if (thisInputVal === '') {
              return true;
            } else {
              response = 'Валидация спама не пройдена';
              return false;
            }
            break;
          case 'date':
            err = 'Неверный формат даты';
            regexp = /(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}/;
            if (isMatched(thisInputVal, regexp, err) === true) {
              return true;
            } else {
              return false;
            }
        }
      };
      results = [];
      for (j = 0, len = thisInputTypeArray.length; j < len; j++) {
        thisInputType = thisInputTypeArray[j];
        results.push((function(thisInputType) {
          if (mainValSwitcher(thisInputType) === true) {
            return true;
          } else {
            return false;
          }
        })(thisInputType));
      }
      return results;
    } else {
      return true;
    }
  };
  return module.each(function() {
    var thisSubmitter;
    thisSubmitter = $(this).find('[type=submit]');
    return thisSubmitter.click(function(e) {
      var XHR, fields, formData, isValid, j, len, modal, preloader, thisActiveSubmitter, thisMod, url, validResponseArray, value;
      thisActiveSubmitter = $(this);
      e.preventDefault();
      thisMod = thisActiveSubmitter.parents("form");
      fields = thisMod.find("." + moduleName + "__input, " + moduleName + "__textarea");
      console.log(fields);
      isValid = true;
      validResponseArray = [];
      fields.each(function() {
        var defPlaceholder, j, len, ref, thisInput, value;
        thisInput = $(this);
        defPlaceholder = thisInput.attr('placeholder');
        if (defPlaceholder === void 0) {
          defPlaceholder = '';
        }
        ref = initValidationSwitch(thisInput);
        for (j = 0, len = ref.length; j < len; j++) {
          value = ref[j];
          console.log(value);
          if (value === false) {
            validResponseArray.push(false);
          } else {
            validResponseArray.push(true);
          }
        }
        return thisInput.click(function() {
          if (thisInput.val() === '') {
            return setDefault(thisInput, defPlaceholder);
          }
        });
      });
      for (j = 0, len = validResponseArray.length; j < len; j++) {
        value = validResponseArray[j];
        if (value === false) {
          isValid = false;
        }
      }
      if (isValid) {
        formData = new FormData();
        $.fn.serializefiles = function(formData) {
          var obj, params, referrer;
          obj = $(this);
          $.each($(obj).find("input[type='file']"), function(i, tag) {
            return $.each($(tag)[0].files, function(i, file) {
              formData.append(tag.name, file);
              console.log(tag.name, file);
              return formData;
            });
          });
          params = $(obj).serializeArray();
          referrer = document.referrer;
          if (!referrer.length) {
            referrer = 'Organic';
          }
          formData.append("referrer", referrer);
          $.each(params, function(i, val) {
            formData.append(val.name, val.value);
            return formData;
          });
          return formData;
        };
        formData = thisMod.serializefiles(formData);
        url = thisMod.attr("action");
        modal = require('../modal/modal');
        preloader = require('../preloader/preloader');
        $(document).ajaxStart(function() {
          return new preloader.init();
        });
        $(document).ajaxStop(function() {
          return new preloader.remove();
        });
        XHR = $.ajax({
          url: url,
          type: 'POST',
          processData: false,
          contentType: false,
          cache: false,
          data: formData
        });
        XHR.done(function(msg) {
          modal('Ваше сообщение отправлено.', 'Скоро мы с вами свяжемся.', true);
          ga('send', 'event', 'submit', 'sendform');
          yaCounter15002683.reachGoal('submit-feedback');
          return true;
        });
        return XHR.fail(function(error) {
          return modal('Ошибка.', 'Перезагрузите страницу.', false);
        });
      }
    });
  });
};

module.exports = jform;
